<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-level-rail" v-if="is_status">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="backClick">返回上一页</el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备名称/终端号/IMEI">
          <el-input placeholder="请输入设备名称/终端号/IMEI" v-model="formInline.search">
           
          </el-input>
        </el-form-item>
        
        <el-form-item label="选择角色" prop="service_role_id">
        <el-select v-model="formInline.grade_id" >
          <template v-for="(item,index) in userGrade">
            <el-option
              :value="item.grade_id"
              :key="index"
              :label="item.name"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>


        <el-form-item label="是否结算">
          <el-select size="small" v-model="formInline.settled" placeholder="请选择是否结算">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未结算" :value="0"></el-option>
            <el-option label="已结算" :value="1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务商名称">
          <el-input placeholder="请输入服务商名称" v-model="formInline.fname">
           
          </el-input>
        </el-form-item>

        <el-form-item label="用户昵称/手机号">
          <el-input placeholder="请输入用户昵称/手机号" v-model="formInline.uname">
           
          </el-input>
        </el-form-item>


        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>


        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>
    
        </el-form-item>

      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="ID"></el-table-column>

           <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div > {{ scope.row.suser.grade_name}}</div>
  
              </template>
            </el-table-column>
              
            <el-table-column prop="type" label="服务商名称">
              <template slot-scope="scope">
                <div > {{scope.row.suser.nickName}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="money" label="产生收入"></el-table-column>
            <el-table-column prop="rate" label="佣金比例"> </el-table-column> 
            <el-table-column prop="price" label="产生佣金"></el-table-column>

            <el-table-column prop="type" label="购买人">
              <template slot-scope="scope">
                <div v-if="scope.row.user"> 昵称：{{ scope.row.user.nickName }}</div>
                <div v-if="scope.row.user"> 手机号：{{ scope.row.user.mobile }}</div>
              </template>
            </el-table-column>
             
            <el-table-column prop="equip.name" label="设备名称"></el-table-column>
            <el-table-column prop="equip.equip_no" label="设备终端号"></el-table-column>
            <el-table-column prop="equip.equip_imei" label="设备IMEI"></el-table-column> 

            <el-table-column prop="type" label="是否结算">
              <template slot-scope="scope">
                <div v-if="scope.row.is_settled == 0" style="color: green;"> 未结算</div>
                <div v-if="scope.row.is_settled == 1" style="color: red;"> 已结算</div>
                <div v-if="scope.row.is_settled == 2" style="color: grey;"> 已取消</div>
              </template>
            </el-table-column>


            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>

   
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :equip_id="equip_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import ServiceApi from '@/api/service.js';
  import EquipApi from '@/api/equip.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          fname:"",
          dtype:0,
          search:"",
          sales:"",
          status:-1,
          address:"",
          create_time:"",
          settled:1,
          uname:"",
          grade_id:0
        },

        open_add:false,
        open_edit:false,
        equip_id:"",
        is_status:false,
        userGrade:[]
      };
    },
    created() {
      this.formInline.search = this.$route.query.equip_no;
      this.formInline.fname = this.$route.query.fs;
      this.is_status = false;
      if(this.$route.query.equip_no || this.formInline.fname){
        this.is_status = true;
      }
      /*获取列表*/
      this.getTableList();
      this.getServiceRole()
    },
    methods: {
      getServiceRole(){
      var self = this;
      ServiceApi.getServiceRole({
      
      }, true)
            .then(data => {
              self.userGrade = data.data
    
      });
    },
      backClick(){
        this.$router.back(-1);
      },
      reast(){
        this.formInline = {
          search:"",
          sales:"",
          status:-1,
          address:"",
          service_role_id:0
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        EquipApi.log(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
  
      /*编辑活动*/
      editClick(row) {
        this.equip_id = row.equip_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            EquipApi.del(
              {
                equip_id: row.equip_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/log.vue